import $ from 'jquery';


    
var username='';//process.env.VUE_APP_CONFLUENCE_USERNAME;
var password='';//process.env.VUE_APP_CONFLUENCE_PASSWORD;

//var server_base_url = window.location.origin+'/confluence';


export interface XTreeItem{
    label:string;
    nodes:XTreeItem[];
}

export function getTreeChildren(
    contextPath: string,
    viewportId:string,
    rootLink:string,
    parentLink:string,
    currentLink:string) {
       // console.log("THE CONTEXT-PATH: ", viewportId);
    return $.ajax({
        //TODO____REMOVE BEFORE DEPLOYMENT
        url: `${contextPath}/rest/scroll-viewport/1.0/tree/children`,
        //url: `http://localhost:8080/rest/scroll-viewport/1.0/tree/children`,
        method: 'GET',
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        headers: {
       //     "Authorization": "Basic " + btoa(username + ":" + password)
        }
        ,
        
        data: {
                'viewportId': viewportId,
                'root': rootLink,
                'parent': parentLink,
                'current': currentLink || ''
        }
    });
}